import React, { useEffect } from 'react'
import { RefActiveParticipantsWithAllPlacements, refreshAllDatasets } from '../hooks/DatasetHooks'
import * as libCon from "../community-hats-js-library/Constants.js"
import * as locCon from "../LocalConstants"
import { Button, Space } from "antd";
import { Typography } from 'antd';
import { RefStoredValue } from '../hooks/GeneralStoreHooks';
import { useNavigate } from 'react-router-dom';
import { DataCollectionStatusCard } from './DashboardCollectionStatus';
import LoadingDatasets from '../components/LoadingDatasets';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions.js';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import { RefContextLanguage } from '../providers/LanguageProvider';


const { Title } = Typography;


function DashboardSingleCollectionStatus() {

  const navigate = useNavigate();

  const i18n = RefContextLanguage()

  // Navigation
  const setCurrentPage = RefSetCurrentPage()


  // Participants
  const [status, participants] = RefActiveParticipantsWithAllPlacements()

  const selectedParticipantId = RefStoredValue(locCon.SELECTED_PARTICIPANT)

  useEffect(() => {

    if (isNullOrUndefined(selectedParticipantId)) {
      setCurrentPage(locCon.PAGE_DASHBOARD_EXPIRY_PARTICIPANTS)
    }


  }, [selectedParticipantId, setCurrentPage])


  return (
    <div className="mainContainer">
      <Title level={2}>{i18n.t('participantsDataCollectionStatus')}</Title>
      <Space direction="horizontal" >
        <Button type="primary" onClick={() => navigate(-1)}>{i18n.t('back')}</Button>
        <Button type="primary" onClick={() => refreshAllDatasets()}>{i18n.t('refreshAll')}</Button>
      </Space>

      <div style={{ marginTop: "5%" }}>
        {
          status === libCon.STATUS_NOT_STARTED || status === libCon.LOADING || participants === null
            ? <LoadingDatasets />
            : status === libCon.ERROR
              ? <div>{i18n.t('error')}</div>
              : <div>
                {
                  selectedParticipantId in participants
                    ? <DataCollectionStatusCard key={participants[selectedParticipantId][libCon.ID]} participant={participants[selectedParticipantId]} />
                    : <Title level={3}>{i18n.t('participantNotFound')}</Title>

                }
              </div>
        }
      </div>
    </div>
  )
}

export default DashboardSingleCollectionStatus